import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

const Development = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function Development({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <>
      <path
        d='M16.2873 4.0716C16.3979 3.81861 16.2826 3.52379 16.0296 3.41311L15.5715 3.2127C15.3185 3.10202 15.0237 3.21738 14.913 3.47037L7.71261 19.9284C7.60192 20.1814 7.71729 20.4763 7.97028 20.5869L8.42835 20.7873C8.68134 20.898 8.97616 20.7827 9.08684 20.5297L16.2873 4.0716Z'
        fill={color}
      />
      <path
        d='M7.62372 5.51466C7.85348 5.66784 7.91557 5.97827 7.76239 6.20804L3.90107 12L7.76239 17.792C7.91557 18.0218 7.85348 18.3322 7.62372 18.4854L7.20769 18.7627C6.97793 18.9159 6.66749 18.8538 6.51432 18.6241L2.28319 12.2774C2.17123 12.1094 2.17123 11.8906 2.28319 11.7227L6.51432 5.37599C6.66749 5.14622 6.97793 5.08413 7.20769 5.23731L7.62372 5.51466Z'
        fill={color}
      />
      <path
        d='M16.3756 5.51466C16.1458 5.66784 16.0838 5.97827 16.2369 6.20804L20.0983 12L16.2369 17.792C16.0838 18.0218 16.1458 18.3322 16.3756 18.4854L16.7916 18.7627C17.0214 18.9159 17.3318 18.8538 17.485 18.6241L21.7161 12.2774C21.8281 12.1094 21.8281 11.8906 21.7161 11.7227L17.485 5.37599C17.3318 5.14622 17.0214 5.08413 16.7916 5.23731L16.3756 5.51466Z'
        fill={color}
      />
    </>
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'development-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Development;
